import { QueryObserverBaseResult } from 'react-query'
import { Query } from '../../../hooks/queries'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import {
  ApiCredentials,
  getApiCredentials
} from './requests/get-api-credentials'

type UseApiCredentials = (props: {
  organizationUuid: string
  enabled: boolean
}) => Pick<QueryObserverBaseResult, 'refetch'> & {
  isLoading: boolean
  apiCredentials: ApiCredentials
}

export const useApiCredentials: UseApiCredentials = ({
  organizationUuid,
  enabled
}) => {
  const { data, isLoading, refetch } = useContrastQuery(
    [Query.API_CREDENTIALS, organizationUuid],
    getApiCredentials,
    {
      organizationUuid
    },
    {
      enabled
    }
  )

  return {
    isLoading,
    refetch,
    apiCredentials: {
      apiKey: !!data ? data.apiKey : '',
      serviceKey: !!data ? data.serviceKey : '',
      userUid: !!data ? data.userUid : '',
      token: !!data ? data.token : ''
    }
  }
}
